import { render, staticRenderFns } from "./ProductCostListModal.vue?vue&type=template&id=4e9d0de2&"
import script from "./ProductCostListModal.vue?vue&type=script&lang=js&"
export * from "./ProductCostListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports